module.exports = __webpack_public_path__ + "static/media/home.d766dd58.svg";